module.exports = __webpack_public_path__ + "static/media/lapiz.d37d9400.svg";